<template>
    <div>
        <template>
            <v-card
                class="mx-auto contact-card"
            >
                 <div  class="declaration-text">
                  <p> {{ translations.home.declarationtext }}
                    <a href="#" @click="openLink('https://kr.afcinfo.org.uk/pages/have-my-say-privacy-notice')">https://kr.afcinfo.org.uk/pages/have-my-say-privacy-notice</a>

                  </p>
            </div>
                <!-- <div v-html="cms_page.html"></div> -->
                <v-btn color="primary" dark v-on:click='accept' block>
                    {{ translations.consentpage.acceptclose }}
                </v-btn>
            </v-card>
        </template>
    </div>
</template>


<script>
export default {
    name: 'Terms',

        methods: {
            accept() {
                localStorage.setItem('terms_accepted', "true")
                this.$router.push("/sign-in")
            },
            openLink(link) {
              if(window.cordova) {
                window.cordova.InAppBrowser.open(link, "_blank") // eslint-disable-line
              } else {
                window.open(link)
              }
            }
        },
        computed: {
          translations() {
            return this.$store.getters.translations;
          }
            // cms_page() {
            //     return hubbdata.getters.getCmsPageById('cms_page_6232')
            // },
        },
}
</script>

<style scoped>
.declaration-text  {
  font-size: 16px;
  padding: 20px;
}
</style>
